module.exports = __webpack_public_path__ + "img/newsImg3-2.2bf0905f.png";